let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("iaT2M")).then(() => parcelRequire('aw2dk'));